import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'polylearn-toeic-service-update',
  templateUrl: './toeic-service-update.component.html',
  styleUrls: ['./toeic-service-update.component.scss']
})
export class ToeicServiceUpdateComponent implements OnInit {
  constructor(private title: Title) {}

  ngOnInit() {
    this.title.setTitle('Nathan TOEIC : information importante');
  }
}
